import script from "./Documents.vue?vue&type=script&setup=true&lang=ts"
export * from "./Documents.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__